import React from 'react';
import { Section, FadeIn, StaggerContainer, StaggerItem } from './ui';
import { Sun, Brain, Moon, Leaf, Heart, Users } from 'lucide-react';
const benefits = [{
  icon: Sun,
  text: 'Energía matutina estable sin depender del café desde los primeros días'
}, {
  icon: Brain,
  text: 'Claridad mental de regreso en menos de 2 semanas'
}, {
  icon: Moon,
  text: 'Sueño profundo y reparador desde el día 7'
}, {
  icon: Leaf,
  text: 'Menos hinchazón y antojos con menús diseñados para ti'
}, {
  icon: Heart,
  text: 'Estabilidad emocional que te devuelve a ti misma'
}, {
  icon: Users,
  text: 'La certeza de que no estás sola en este camino'
}];
export const BenefitsSection = () => {
  return <Section bg="bg-white" data-id="element-32">
      <FadeIn data-id="element-33">
        <div className="text-center max-w-3xl mx-auto mb-12 md:mb-16" data-id="element-34">
          <span className="inline-flex items-center gap-2 text-coral font-bold tracking-wider uppercase text-sm mb-4" data-id="element-35">
            Lo que vas a recuperar
          </span>
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold text-brown leading-tight" data-id="element-36">
            Tu vida en{' '}
            <span className="text-gold italic font-normal" data-id="element-37">21 días</span>
          </h2>
        </div>
      </FadeIn>

      <StaggerContainer className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-8 max-w-4xl mx-auto" data-id="element-38">
        {benefits.map((benefit, idx) => <StaggerItem key={idx} data-id="element-39">
            <div className="bg-cream-light border border-cream-dark rounded-3xl p-6 md:p-7 flex items-center gap-4 md:gap-5 shadow-sm hover:shadow-md transition-shadow h-full" data-id="element-40">
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-full bg-sage-light/50 flex items-center justify-center shrink-0" data-id="element-41">
                <benefit.icon className="w-6 h-6 md:w-7 md:h-7 text-sage" data-id="element-42" />
              </div>
              <p className="text-base md:text-lg text-brown font-medium leading-relaxed" data-id="element-43">
                {benefit.text}
              </p>
            </div>
          </StaggerItem>)}
      </StaggerContainer>
    </Section>;
};